/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Go_Further_Boiler_RoomInputs */



/**
* | output |
* | --- |
* | "Boiler room" |
*
* @param {Go_Further_Boiler_RoomInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const go_further_boiler_room = /** @type {((inputs?: Go_Further_Boiler_RoomInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Go_Further_Boiler_RoomInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Boiler room")
	return /** @type {LocalizedString} */ ("Chaufferie")
});